import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './NotificationHolder.css';
import * as actionTypes from '../../../store/actions';
import Notification from './Notification/Notification';

class NotificationHolder extends Component {

  state = {
    keyCounter: 0
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.notifications !== this.props.notifications;
  }

  componentWillUnmount() {
    this.props.resetNotifications();
  }

  render() {

    let notifications = [...this.props.notifications].map((notification, index) => {
      return (
        <Notification
          key={notification.key}
          notificationType={notification.notificationType}
          closeNotification={() => this.props.removeNotification(index)} >
          { notification.notification }
        </Notification>
      )
    });

    return (
      <div
        className={classes.NotificationHolder}>
        { notifications }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    notifications: state.notifications
  };
}

const mapDispatchToProps = dispatch => {
  return {
    addNotification: (notification, notificationType) => dispatch({ type: actionTypes.ADD_NOTIFICATION,
                                                                   notification: notification,
                                                                   notificationType: notificationType }),
    removeNotification: (index) => dispatch({ type: actionTypes.REMOVE_NOTIFICATION,
                                              index: index }),
    resetNotifications: () => dispatch({ type: actionTypes.RESET_NOTIFICATION })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationHolder);



// WEBPACK FOOTER //
// ./src/components/UI/NotificationHolder/NotificationHolder.js